import React, { useEffect, useRef, useState } from "react";
import { X } from 'lucide-react';

const TagsModal = ({ isOpen, onClose, platform, onSave }) => {
    console.log('platform >>', platform);

    if (!isOpen) return null;
    return (
        <div className="user-modal-overlay">
      <div className="user-modal-container">
        <div className="user-modal-header">
          <h2 className='createpost-modal-title'>HashTags Trending on {platform ? platform : null}</h2>
          <button onClick={onClose} className="user-modal-close-btn">
            <X size={20} />
          </button>
        </div>

        <p>No data</p>
      </div>
    </div>
    )
}

export default TagsModal